import { StateCreator } from 'zustand';
import { EmojiPickerSlice, EmojiPickerSliceState } from './index.types';

const initialState: EmojiPickerSliceState = {
  isEmojiPickerOpen: false,
  isEditingEmoji: false,
};

export const createEmojiPickerSlice: StateCreator<EmojiPickerSlice> = (set, get) => ({
  ...initialState,
  setEmojiPickerState: (state) => {
    set((currentState) => ({
      ...currentState,
      ...state,
    }));
  },
  getEmojiPickerState: () => {
    const state = get();
    return {
      isEmojiPickerOpen: state.isEmojiPickerOpen,
      isEditingEmoji: state.isEditingEmoji,
    };
  },
  resetEmojiPicker: () => {
    set((state) => ({ ...state, ...initialState }));
  },
});